import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { BasePage } from '../../base.page';
import { Client } from '../../../domain/data';
import { CheckClientUseCase, ClientRelation, ClientType, GetFirstHolderUseCase, UpdateFirstHolderUseCase } from '../../../../core';
import { ContractPage } from '../contract.page';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { ErrorAddingParticipantDialog } from '../../../ui/dialog/error-adding-participant/error-adding-participant.dialog';
import { MainRoutes } from '../../../main-routes.enum';
import { ParentEvents } from '../../../utils/parent-events.service';
import { RecaptchaDirective } from '../../../directives/recaptcha.directive';

import { environment } from '../../../../../environments/environment';

@Component({
    templateUrl: './contract-form.page.html',
    styleUrls: ['./contract-form.page.scss'],
})
export class ContractFormPage extends BasePage implements AfterViewInit, OnInit, OnDestroy {
    public ClientRelation: typeof ClientRelation = ClientRelation;
    public ClientType: typeof ClientType = ClientType;

    public client: Client;
    public isClientPortal = environment.portalClient;

    private backSubscription: Subscription;

    @ViewChild('recaptchaDirective')
    recaptchaDirective: RecaptchaDirective;

    constructor(
        contractPage: ContractPage,
        parentEvents: ParentEvents,
        private checkClientUseCase: CheckClientUseCase,
        private dialog: MatDialog,
        private getFirstHolderUseCase: GetFirstHolderUseCase,
        private renderer: Renderer2,
        private router: Router,
        private updateFirstHolderUseCase: UpdateFirstHolderUseCase
    ) {
        super(parentEvents);
        contractPage.showBackButton();
        this.backSubscription = contractPage.back.subscribe(() => {
            window.history.back();
        });
    }

    ngOnInit() {
        this.getFirstHolderUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.client = transaction.data as Client;
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }

    ngOnDestroy() {
        this.backSubscription.unsubscribe();
    }

    onSubmit() {
        if (this.isClientPortal) {
            this.recaptchaDirective.refresh().then(() => {
                this.checkClientUseCase
                    .bind({
                        client: this.client,
                        captcha: this.client.recaptchaToken,
                    })
                    .subscribe((transaction) => {
                        if (transaction.isSuccess) {
                            this.updateAndRedirect();
                        } else if (!transaction.isAuthError) {
                            this.dialog.open(ErrorAddingParticipantDialog, {
                                data: transaction.error,
                            });
                        }
                    });
            });
        } else {
            this.updateAndRedirect();
        }
    }

    private updateAndRedirect() {
        this.updateFirstHolderUseCase.bind({ client: this.client }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.router.navigateByUrl(MainRoutes.NEW_CONTRACT_PARTICIPANTS);
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }
}
